package com.milta.core.localization.translations.bg

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "AI",
    menuAiLegend = "AI: автоматично разчитане чрез изкуствен интелект, което използва вашия AI кредит. За Excel – само ако колоните не са разпознати.",
    menuExhaustedTitle = "AI кредитът е изчерпан — нулиране на {date}.",
    menuExhaustedMessage = "Сканирането и импортът на PDF са деактивирани. Таблица с очакваните колони и ръчното въвеждане остават възможни.",
    modeDisabledReason = "AI кредитът е изчерпан",
    exhaustedBannerWebTitle = "AI кредитът е изчерпан — нулиране на {date}.",
    exhaustedBannerWebMessage = "PDF файловете вече не могат да бъдат анализирани. Импортирайте Excel или CSV файл с очакваните колони или добавете доставките ръчно от мобилното приложение.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) или CSV · макс. 500 спирки · 10 MB",
    pdfUnavailableUntil = "PDF не е наличен до {date}",
    pdfRefusedTitle = "AI кредитът е изчерпан — този PDF не може да бъде анализиран",
    pdfRefusedMessage = "„{file}“ изисква прочитане от AI. Кредитът ви се възстановява на {date}. Дотогава импортирайте Excel или CSV файл с очакваните колони или добавете доставките ръчно от мобилното приложение.",
    spreadsheetExhaustedTitle = "Неразпознати колони — AI кредитът е изчерпан",
    spreadsheetExhaustedWebMessage = "Колоните на „{file}“ не съответстват на очакваните колони, а AI кредитът ви вече не позволява автоматичното им разпознаване (възстановяване на {date}). Преименувайте колоните както е показано по-долу или добавете доставките ръчно от мобилното приложение.",
    expectedColumnsNoCreditHint = "Файл, който следва тези колони, се импортира без AI и не използва кредит, дори при 0%.",
    importExhaustedTitle = "AI кредитът е изчерпан",
    importExhaustedPhotoMessage = "AI кредитът ви стигна 0%, докато този импорт чакаше. Снимката не беше анализирана и нищо не беше отчетено. Нулиране на {date}.",
    importExhaustedFileMessage = "AI кредитът ви стигна 0%, докато този импорт чакаше. Файлът не беше анализиран и нищо не беше отчетено. Нулиране на {date}.",
    importSpreadsheetExhaustedMessage = "Колоните на този файл не съответстват на очакваните колони, а AI кредитът ви вече не позволява автоматичното им разпознаване. Нулиране на {date}.",
    stepPhotoSent = "Снимката е изпратена",
    stepFileSent = "Файлът е изпратен: {file}",
    stepAnalysisNotStarted = "Анализът не е стартиран: AI кредитът е изчерпан",
    stepFileRead = "Файлът е прочетен: {file}",
    stepExpectedColumns = "Очаквани колони: Име на получателя, Пълен адрес",
    stepDeliveriesKept = "Вече въведените доставки са запазени",
    retryAvailableOn = "Опитай отново — налично на {date}",
    manualEntryAction = "Ръчно въвеждане",
    myUsageTitle = "Моето използване",
    myUsageAttachedDriverNote = "Тук се показват само вашите собствени действия. Това, което фирмите ви стартират за вас, се отчита при тях.",
    tabOptimizations = "Оптимизации",
    tabAiCredit = "AI кредит",
    remainingForPeriod = "Оставащ AI кредит за периода",
    percentValue = "{percent}%",
    remainingSuffix = "оставащ AI кредит",
    lowPill = "Нисък кредит",
    exhaustedPill = "Изчерпан · сканирането и импортът на PDF са деактивирани",
    driverNote = "Кредитът ви се възстановява при подновяване на абонамента (този на вашата Фирма, ако сте част от такава). Неизползваният кредит не се прехвърля.",
    enterpriseNote = "Възстановява се при подновяване на абонамента ви, без прехвърляне. Този кредит обхваща само вашите AI действия; всеки шофьор има свой.",
    exhaustedNote = "Ръчното въвеждане и таблиците с очакваните колони остават достъпни. Кредитът се възстановява при подновяване на абонамента ви.",
    webScopeHint = "Този кредит обхваща само AI действията на този акаунт: сканирания, импорти на PDF или снимки, неразпознати колони в таблици. Всеки шофьор има свой.",
    profileValue = "{optimizations} · AI {percent}%",
    profileValueAiOnly = "AI {percent}%",
    columnShare = "Дял от кредита",
    actionScanDeliveryList = "Сканиране на списък",
    actionScanPackageLabel = "Сканиране на етикет",
    actionImportPdf = "Импорт на PDF",
    actionImportUnstructured = "Импорт във фонов режим",
    actionSpreadsheetMapping = "Колони на таблица (AI)",
    outcomeSuccess = "Успешно",
    outcomeFailed = "Неуспешно",
    outcomeUnreadable = "Нечетимо",
    countedSuffix = "(отчетено)",
    rowDateTime = "{date} в {time}",
    limitsEyebrow = "AI кредит за период",
    limitsDescription = "Сума в евро, която всеки акаунт може да изразходва за AI заявки (сканирания, импорти на PDF или снимки, неразпознати колони в таблици) за абонаментен период. Кредитът се връща до лимита при подновяване на абонамента, без прехвърляне.",
    weightedEquivalent = "≈ {tokens} претеглени токена",
    limitsFootnote = "Шофьор на Фирма получава лимита „Шофьор“, пробен докато Фирмата му е в пробен период. Еквивалентът в токени е ориентировъчен и се преизчислява с курса по-долу.",
    conversionEyebrow = "Конвертиране и предупреждение",
    rateLabel = "Обменен курс",
    rateHint = "Обновява се ръчно · прилага се за следващите заявки",
    thresholdLabel = "Предупреждение за нисък кредит",
    thresholdUnit = "% оставащ",
    thresholdHint = "Процент в оранжево и банер веднъж на период",
    calculationTitle = "Как се изчислява цената на една заявка.",
    calculationBody = "Claude Haiku 4.5: 1 $ за милион входни токена, 5 $ за милион изходни токена. Претеглен токен = вход × 1 + изход × 5, следователно 1 $ = 1 000 000 претеглени токена. Цена в евро = цена в долари ÷ курс. Пример: средно сканиране на списък (5 014 вход + 1 792 изход) = 13 974 претеглени токена = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Лимитите са записани.",
    settingsSavedDetail = "Фирма: {enterpriseTrial} пробен · {enterprisePaid} платен. Шофьор: {driverTrial} пробен · {driverPaid} платен. Курс {rate}. Предупреждение {threshold}%.",
    limitTooHigh = "Максимум 1 000 €.",
    rateTooHigh = "Максимум 10.",
    thresholdOutOfRange = "Между 1 и 99.",
    adminCreditTitle = "AI кредит",
    adminRemainingLine = "≈ {tokens} оставащи претеглени токена · изразходвани {consumed}",
    adminOverrunLine = "Изразходвани {consumed} · превишение с {over}",
    adminLowPill = "Нисък кредит · под {threshold}%",
    adminLowPillNoThreshold = "Нисък кредит",
    adminExhaustedPill = "Кредитът е изчерпан · AI действията са деактивирани",
    adminAppliedAfterReplacement = "{consumed} изразходвани + {remaining} оставащи (замяна)",
    adminGlobalLimitLabel = "Глобален лимит",
    adminGlobalLimitResumes = "{source} — важи отново от нулирането",
    adminResetNoCarryOver = "Започва отново от {limit}: превишението не се прехвърля",
    replaceLabel = "Замяна на оставащия кредит",
    replaceHelp = "От 0 до 100 €, само за текущия период. При нулирането акаунтът започва отново от глобалния лимит.",
    replaceHelpEnterpriseDriver = "Променя само кредита на {name}. Този на Фирмата и на другите шофьори не се променя.",
    replaceInvalid = "Въведете сума от 0 до 100 €.",
    replacedTitle = "Оставащият кредит е заменен: {from} → {to}.",
    replacedDetail = "За текущия период. На {date} връщане към глобалния лимит ({limit}).",
    adminHistoryTitle = "История на AI кредита",
    adminPeriodSummary = "Текущ период от {start}: {calls} заявки · {failed} неуспешни или нечетими (отчетени) · {tokens} претеглени токена · {consumed}",
    columnInput = "Вход",
    columnOutput = "Изход",
    columnWeighted = "Претеглени",
    columnCost = "Цена",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "AI кредитът ви е изчерпан. Файлът не беше анализиран и нищо не беше отчетено. Нулиране на {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
